const heading = 'Permanently delete video?'
const body = 'This deletion will be permanent and cannot be undone'

const successHeading = 'Deleted Successfully'
const successBody = 'The screen recording video for this contact has been deleted'

const errorHeading = 'Error'
const errorBody = 'Deletion request failed'
export { body, errorBody, errorHeading, heading, successBody, successHeading }
